import { BrowserRouter as Router, Route, Routes } from 'react-router-dom';

import "./styles.css";
import "./style/webtour.css";

import WebTour from "./pages/webtour";
import { createRoot } from "react-dom/client";
import React from "react";

function App() {
  return (
    <div className="App">
      <Router>
        <Routes>
          <Route path="/" element={<WebTour param="8K" />} />
          <Route
            path="/4K"
            element={<WebTour param="4K" />}
          />
          <Route
            path="/8K"
            element={<WebTour param="8K" />}
          />
          <Route
            path="/16K"
            element={<WebTour param="16K" />}
          />
        </Routes>
      </Router >
    </div>
  );
}

const rootElement = document.getElementById("root");
const root = createRoot(rootElement)
root.render(<App />);
